<template>
  <div class="catalog-container">
    <h1 class="title " style="text-align: left; font-size: calc(1rem + 2vw); color: white; font-weight: bold ">{{ title }}</h1>
    <div class="row row-cols-1 gy-4 gx-3 px-3 ps-0 pe-0" >
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style">
          <img src="/assets/roster7.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.4vw); padding-top: 1%; font-weight: bold">Ростер для 7 перепёлок</h2>
            <p class="card-text" style="color:black; text-align: left;">Можно использовать для <span class="underline">гриля</span>, <span class="underline">духовки</span>, <span class="underline">коптильни.</span></p>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p style="color: #ED5500FF; font-size: calc(1rem + 0.5vw); font-weight: bold ">2600 ₽</p>
            </div>
            <div class="catalog-button-buy-container">
              <a type="button" class="btn btn-lg catalog_buy_button px-2 py-2" target="_blank" @click="openMoreDetails7" style="font-size: calc(1rem + 0.5vw); width: 100%">Подробнее</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style">
          <img src="/assets/roster9.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.4vw); padding-top: 1%; font-weight: bold">Ростер для 9 перепёлок</h2>
            <p class="card-text" style="color:black; text-align: left;">Можно использовать для <span class="underline">гриля</span>, <span class="underline">духовки</span>, <span class="underline">коптильни.</span></p>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p style="color: #ED5500FF; font-size: calc(1rem + 0.5vw); font-weight: bold ">3780 ₽</p>
            </div>
            <div class="catalog-button-buy-container">
              <button type="button" class="btn btn-lg catalog_buy_button px-2 py-2" @click="openMoreDetails9" style="font-size: calc(1rem + 0.5vw); width: 100%">Подробнее</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style">
          <img src="/assets/roster17.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.4vw); padding-top: 1%;font-weight: bold">Ростер для 17 перепёлок</h2>
            <p class="card-text" style="color:black; text-align: left;">Можно использовать для <span class="underline">гриля</span>, <span class="underline">коптильни.</span></p>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p style="color: #ED5500FF; font-size: calc(1rem + 0.5vw); font-weight: bold ">7140 ₽</p>
            </div>
            <div class="catalog-button-buy-container">
              <button type="button" class="btn btn-lg catalog_buy_button px-2 py-2" @click="openMoreDetails17" style="font-size: calc(1rem + 0.5vw); width: 100%">Подробнее</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style">
          <img src="/assets/roster23.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.4vw); padding-top: 1%; font-weight: bold">Ростер для 23 перепёлок</h2>
            <p class="card-text" style="color:black; text-align: left;">Можно использовать для <span class="underline">гриля</span>, <span class="underline">духовки</span>, <span class="underline">коптильни.</span></p>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p style="color: #ED5500FF; font-size: calc(1rem + 0.5vw); font-weight: bold ">9000 ₽</p>
            </div>
            <div class="catalog-button-buy-container">
              <button type="button" class="btn btn-lg catalog_buy_button px-2 py-2" @click="openMoreDetails23" style="font-size: calc(1rem + 0.5vw); width: 100%">Подробнее</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue'; // Импортируйте onMounted
const router = ref(null); // Создайте ref для router
const openMoreDetails7 = () => {
  router.value.push('/product/roaster-for-7-quails').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
const openMoreDetails9 = () => {
  router.value.push('/product/roaster-for-9-quails').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
const openMoreDetails17 = () => {
  router.value.push('/product/roaster-for-17-quails').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
const openMoreDetails23 = () => {
  router.value.push('/product/roaster-for-23-quails').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
onMounted(() => { // Выполните код после монтирования компонента
  router.value = useRouter();
});
</script>
<script>
export default {
  name: 'CatalogMainScreen',
  props: {
    title: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.catalog-button-buy-container {
  width: 100%;
  text-align: center;
  position: relative;

}
.catalog_buy_button {
  height: 20%;
  border-radius: 0 !important;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  background-color: #ffffff;
  color: #ED5500FF;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  max-width: 100%;
  outline: none;
  text-align: center;
  text-decoration: none;
  vertical-align: bottom;
}
.catalog_buy_button:hover {
  background-color: #ffffff;
  color: #ED5500FF;
  box-shadow: 0 8px 24px 0 rgba(242, 242, 242, 0.2);
}

.underline {
  text-decoration: underline;
}
.product-style{
  background-color: #F2F2F2FF;
  width: auto;
  padding: 3%;
  border-radius: 0;
  align-items: center
}
.catalog-container{
  position: relative;

  margin-bottom: 5%;
  min-width: 15%;

  width: auto;
}
.card-text{
  min-height: 48px!important;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
